// extracted by mini-css-extract-plugin
export default {"copyable":"styles_copyable__MldPq","installBlock":"styles_installBlock__T5CvQ","disabled":"styles_disabled__e6T6d"};